var _g, _path, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAccountIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "4 1 28 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_5871_2541)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 28,
    width: 28,
    height: 28,
    rx: 14,
    transform: "rotate(-90 4 28)",
    fill: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 4.5,
    y: 27.5,
    width: 27,
    height: 27,
    rx: 13.5,
    transform: "rotate(-90 4.5 27.5)",
    stroke: "black"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.9999 5.1665C19.0473 5.16618 20.0672 5.50164 20.91 6.12354C21.7529 6.74558 22.375 7.62147 22.6835 8.62256C22.992 9.62362 22.9714 10.6975 22.6249 11.686C22.2783 12.6746 21.6237 13.5264 20.7577 14.1157L19.953 14.6626L20.8671 14.9985C22.4298 15.5718 23.785 16.5996 24.7587 17.9497C25.7324 19.2999 26.2804 20.9107 26.3309 22.5747V22.5845C26.3325 22.6159 26.3279 22.6477 26.3173 22.6772C26.3066 22.7068 26.2898 22.7342 26.2684 22.7573C26.2472 22.7803 26.2217 22.799 26.1932 22.812C26.1647 22.825 26.1337 22.8325 26.1024 22.8335C26.071 22.8344 26.039 22.8282 26.0096 22.8169C25.9805 22.8056 25.954 22.7887 25.9315 22.7671C25.9089 22.7453 25.8902 22.7188 25.8778 22.6899C25.8655 22.6612 25.8595 22.6303 25.8593 22.5991L25.8583 22.5874L25.8378 22.2056C25.687 20.3046 24.8495 18.5179 23.4745 17.1841C22.0076 15.7613 20.0435 14.9653 17.9999 14.9653C15.9564 14.9654 13.9931 15.7614 12.5262 17.1841C11.1512 18.5179 10.3137 20.3045 10.163 22.2056L10.1415 22.5874C10.1396 22.6501 10.1129 22.7094 10.0673 22.7524C10.0216 22.7954 9.96099 22.8188 9.89832 22.8169C9.83564 22.815 9.77628 22.7883 9.73328 22.7427C9.69035 22.6971 9.66704 22.6363 9.66882 22.5737C9.71952 20.9099 10.2673 19.2988 11.2411 17.9487C12.2148 16.599 13.5702 15.5717 15.1327 14.9985L16.0468 14.6626L15.2421 14.1157C14.376 13.5264 13.7214 12.6746 13.3749 11.686C13.0283 10.6975 13.0078 9.62364 13.3163 8.62256C13.6248 7.62155 14.246 6.74556 15.0887 6.12354C15.8789 5.54035 16.8253 5.20927 17.8036 5.17041L17.9999 5.1665ZM17.9999 5.63916C16.826 5.63916 15.7001 6.10511 14.87 6.93506C14.04 7.76508 13.5732 8.89113 13.5731 10.0649C13.5731 11.2389 14.0399 12.3657 14.87 13.1958C15.7001 14.0257 16.8261 14.4917 17.9999 14.4917C19.1737 14.4917 20.2997 14.0258 21.1298 13.1958C21.9599 12.3657 22.4266 11.2389 22.4266 10.0649C22.4265 8.89113 21.9598 7.76508 21.1298 6.93506C20.2997 6.10507 19.1737 5.63919 17.9999 5.63916Z",
    fill: "white",
    stroke: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_5871_2541",
    x: 0,
    y: 0,
    width: 36,
    height: 36,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_5871_2541"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_5871_2541",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAccountIcon);
export default __webpack_public_path__ + "static/media/accountIcon.23c124a79b09dd21978af042d3960c3d.svg";
export { ForwardRef as ReactComponent };